import { ReactNode } from "react";

export interface ItemProps {
	image?: string;
	logo?: string;
	logoClass?: string;
	title: string;
	git?: string;
	date?: string;
	where?: string;
	skills?: ReactNode[];
	desc?: ReactNode;
	children?: ReactNode;
	id?: string;
}

export default function Item(props: ItemProps) {
	return (
		<div className="flex" id={props.id}>
			<div className="max-2xl:hidden mr-10 flex justify-end">
				{props.image && (
					<img
						src={props.image}
						alt={props.where}
						className="size-60 rounded-md shadow-x mt-14"
					></img>
				)}
			</div>
			<div className="border-l flex-grow pb-10 pl-10 relative">
				<i className="bi bi-dot text-7xl absolute -top-5 -left-9"></i>

				{props.date && (
					<div className="text-2xl mb-4">{props.date}</div>
				)}

				{props.logo && (
					<img
						src={props.logo}
						alt={props.where}
						className={`${
							props.logoClass ?? "size-12 mb-4"
						} mr-4 float-left relative`}
					></img>
				)}

				<h3 className="font-bold text-2xl">{props.title}</h3>

				{props.where && (
					<strong className="text-sm">{props.where}</strong>
				)}

				{props.git && (
					<a
						className="shadow-white text-sm hover:text-shadow hover:scale-110 underline"
						href={props.git}
					>
						Lien Github
						<i className="pl-2 bi bi-box-arrow-right"></i>
					</a>
				)}

				{props.desc && (
					<p className="text-justify mt-4">{props.desc}</p>
				)}

				<hr className="text-[#5b6670] my-4 clear-both" />

				{props.skills && (
					<ul className="pl-4 list-disc">
						{props.skills.map((skill, i) => (
							<li key={i}>{skill}</li>
						))}
					</ul>
				)}

				{props.children}
			</div>
		</div>
	);
}
